webpackJsonp([0],{

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(79)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(85),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\project\\vue2-img-upload\\src\\App.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] App.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-57da2ff5", Component.options)
  } else {
    hotAPI.reload("data-v-57da2ff5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImgUpload_vue__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ImgUpload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ImgUpload_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      url: 'https://comment-dop79.djtest.cn/comment/api/upload',
      images: [],
      images2: [],
      images3: [],
      extraData: {}
    };
  },

  methods: {
    onSuccess: function onSuccess(data, img, list) {
      if (data.code == 0) {
        console.log(123);
      } else {
        return false;
      }
    },
    onError: function onError(data, img, list) {
      alert('上传失败');
    },
    onComplete: function onComplete(data, img, list) {
      alert('上传完成');
    },
    beforeUpload: function beforeUpload(file) {
      console.log(file);
      if (file.size > 1024 * 1024 * 10) {
        alert('上传图片不得大于10M！');
        return false;
      }
    }
  },
  components: {
    ImgUpload: __WEBPACK_IMPORTED_MODULE_0__components_ImgUpload_vue___default.a
  }
});

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);


function loadJSFile(src, cb) {
    var script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.onload = function () {
        cb && cb();
    };
    script.setAttribute("src", src);
    document.getElementsByTagName("head").item(0).appendChild(script);
}

function loadCSSFile(src, cb) {
    var style = document.createElement("link");
    style.setAttribute("rel", "stylesheet");
    style.onload = function () {
        cb && cb();
    };
    style.setAttribute("href", src);
    document.getElementsByTagName("head").item(0).appendChild(style);
}
/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        max: {
            type: Number,
            default: 6
        },

        url: {
            type: String,
            require: true
        },

        imagePreviewList: {
            type: Array,
            default: function _default() {
                return [];
            }
        },

        beforeUpload: {
            type: Function
        },

        onComplete: {
            type: Function
        },

        onSuccess: {
            type: Function
        },

        onError: {
            type: Function
        },

        isPreview: {
            type: Boolean,
            default: true
        },

        name: {
            type: String,
            default: 'image'
        },

        extraData: {
            type: Object
        },

        isClip: {
            type: Boolean,
            default: false
        },

        clipData: {
            type: Object,
            default: {
                width: 290,
                height: 290,
                rate: 3,
                background: '#fff'
            }
        }
    },

    data: function data() {
        return {
            isWx: navigator.userAgent.indexOf('MicroMessenger') >= 0,
            isIOS: !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
            isSwiper: false,
            currSwiperIndex: 1,
            clipImg: {
                scale: 1,
                lastScale: 0,
                rate: 0,
                left: 0,
                top: 0,
                width: 0,
                height: 0,
                sx: 0,
                sy: 0,
                sw: 0,
                sh: 0,
                dx: 0,
                dy: 0,
                dw: 0,
                dh: 0 },
            screenObj: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight },
            showClip: false,
            clipImgUrl: ''
        };
    },
    created: function created() {
        if (this.isPreview || 'function' !== typeof Swiper) {
            loadCSSFile('//static.daojia.com/assets/common/css/swiper-3.4.0.min.css');
            loadJSFile('//static.daojia.com/assets/common/js/swiper-3.4.0.min.js', function () {
                console.log('swiper.js加载成功');
            });
        }

        if (this.isClip) {
            loadJSFile('//static.djtest.cn/fe/other/lx20170226/clip/js/touch.min.js', function () {
                console.log('touch.js加载成功');
            });
        }

        loadJSFile('//static.daojia.com/assets/common/js/exif.js', function () {
            console.log('加载EXIF模块成功');
        });

        loadJSFile('//static.daojia.com/assets/common/js/toBlob.js', function () {
            console.log('加载toBlob模块成功');
        });
    },
    mounted: function mounted() {},


    methods: {
        openUploadPop: function openUploadPop(e, index) {
            if (index) {
                this.$refs['upload' + index].value = '';
                this.$refs['upload' + index].click();
            } else {
                this.$refs.upload.value = '';
                this.$refs.upload.click();
            }
        },
        analyzeImg: function analyzeImg(originImg, cb) {
            var _this = this;

            if (originImg) {
                if (!/image\/\w+/.test(originImg.type)) {
                    return false;
                }

                try {
                    var reader = new FileReader();
                    reader.readAsDataURL(originImg);

                    reader.onload = function (e) {
                        var img = new Image();
                        img.src = e.target.result;

                        if (img.complete) {
                            callback();
                        } else {
                            img.onload = callback;
                        }

                        function callback() {
                            _this.compress(img, function (blob, data, resultWidth, resultHeight) {
                                if (_this.isClip) {

                                    var uploadImg = document.querySelector('.clip-img');
                                    var clip = document.querySelector('.clip-wrap');

                                    _this.clipImgUrl = data;
                                    _this.setBorder();
                                    _this.setImgCenter('.clip-img');

                                    if (resultWidth > resultHeight) {
                                        uploadImg.style.width = '100%';
                                    } else {
                                        uploadImg.style.height = '100%';
                                    }
                                    _this.bindEvents(clip, uploadImg);
                                } else {
                                    cb && cb(blob, data);
                                }
                            });
                        }
                    };
                } catch (e) {
                    alert('不支持h5上传');
                    return false;
                }
            } else {
                return false;
            }
            return true;
        },
        compress: function compress(img, cb) {
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext('2d');
            var tCanvas = document.createElement("canvas");
            var tctx = tCanvas.getContext("2d");
            var rCanvas = document.createElement("canvas");
            var rctx = rCanvas.getContext("2d");

            var initSize = img.src.length;
            var width = img.width;
            var height = img.height;
            var count = void 0,
                ratio = void 0,
                resultWidth = void 0,
                resultHeight = void 0;

            var orient = this.getOrientation(img);

            if ((ratio = width * height / 4000000) > 1) {
                ratio = Math.sqrt(ratio);
                width /= ratio;
                height /= ratio;
            } else {
                ratio = 1;
            }

            canvas.width = rCanvas.width = width;
            canvas.height = rCanvas.height = height;
            resultWidth = canvas.width;
            resultHeight = canvas.height;
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            if ((count = width * height / 1000000) > 1) {
                count = ~~(Math.sqrt(count) + 1);
                var nw = ~~(width / count);
                var nh = ~~(height / count);

                tCanvas.width = nw;
                tCanvas.height = nh;

                for (var i = 0; i < count; i++) {
                    for (var j = 0; j < count; j++) {
                        tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                        ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                    }
                }
            } else {
                ctx.drawImage(img, 0, 0, width, height);
            }

            if (orient && orient != 1) {
                rctx.drawImage(canvas, 0, 0, width, height);
                ctx.clearRect(0, 0, width, height);
                ctx.save();
                ctx.translate(canvas.width / 2, canvas.height / 2);
                switch (orient) {
                    case 6:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(90 * Math.PI / 180);
                        ctx.drawImage(rCanvas, 0, -height);
                        break;
                    case 3:
                        ctx.rotate(180 * Math.PI / 180);
                        ctx.drawImage(rCanvas, -width / 2, -height / 2);
                        break;
                    case 8:
                        canvas.width = height;
                        canvas.height = width;
                        ctx.rotate(270 * Math.PI / 180);
                        ctx.drawImage(rCanvas, -width, 0);
                        break;
                }
                ctx.restore();
            }
            if (orient && (orient == 6 || orient == 8)) {
                resultWidth = height;
                resultHeight = width;
            }
            if (resultWidth > resultHeight) {
                this.clipImg.rate = this.screenObj.width / resultWidth;
            } else {
                this.clipImg.rate = this.screenObj.height / resultHeight;
            }
            this.clipImg.width = resultWidth * this.clipImg.rate;
            this.clipImg.height = resultHeight * this.clipImg.rate;

            var imagData = canvas.toDataURL('image/jpeg', 0.8);
            canvas.toBlob(function (blob) {
                cb && cb(blob, imagData, resultWidth, resultHeight);
            }, 'image/jpeg', 0.8);

            tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        },
        uploadImg: function uploadImg(e, clipFile, clipData) {
            var _this2 = this;

            for (var i = 0; i < e.target.files.length; i++) {
                if (!this.beforeUpload || this.beforeUpload(e.target.files[i]) !== false) {
                    if (e.target.files[i] && /image\/\w+/.test(e.target.files[i].type)) {
                        (function () {
                            var curImg = {
                                data: '',
                                url: '',
                                isUploading: true,
                                isError: false
                            };
                            if (_this2.imagePreviewList.length < _this2.max) {
                                if (!_this2.showClip) {
                                    _this2.imagePreviewList.push(curImg);
                                    _this2.analyzeImg(e.target.files[i], function (file, data) {
                                        curImg.data = data;
                                        var curIndex = _this2.imagePreviewList.length - 1;
                                        _this.uploadFile(file, curIndex);
                                    });
                                }
                            }
                        })();
                    }
                }
            }
        },
        getOrientation: function getOrientation(img) {
            var orient = null;
            if ('function' == typeof EXIF) {
                EXIF.getData(img, function () {
                    orient = EXIF.getTag(this, 'Orientation');
                });
                return orient;
            } else {
                console.log('未加载EXIF模块');
            }
        },
        delImage: function delImage(index, img) {
            if (img.isUploading) {
                img.isUploading = false;
            }
            this.imagePreviewList.splice(index, 1);
        },
        imgSwiper: function imgSwiper(index) {
            this.createSwiper(index);
        },
        createSwiper: function createSwiper(index) {
            this.isSwiper = true;

            this.currSwiperIndex = index + 1;
            var _this = this;
            var mySwiper = new Swiper('.swiper-container', {
                direction: 'horizontal',
                initialSlide: index,
                observer: true,
                observeParents: true,
                onTransitionEnd: function onTransitionEnd(swiper) {
                    _this.currSwiperIndex = swiper.activeIndex + 1;
                }
            });
        },
        hideSwiper: function hideSwiper() {
            this.isSwiper = false;
        },
        setBorder: function setBorder() {
            this.showClip = true;
            var imgContainer = document.querySelector('.clip-container');
            var clipWrap = document.querySelector('.clip-wrap');
            imgContainer.setAttribute('style', "width:" + this.screenObj.width + "px;height:" + this.screenObj.height + "px");
            clipWrap.setAttribute('style', "border-top-width:" + this.computerBorder('top') + ";border-left-width:" + this.computerBorder('left') + ";border-bottom-width:" + this.computerBorder('top') + ";border-right-width:" + this.computerBorder('right'));
        },
        computerBorder: function computerBorder(orient) {
            if (orient == 'top' || orient == 'bottom') {
                var top = (this.screenObj.height - this.clipData.height) / 2;
                return top + "px";
            } else {
                var left = (this.screenObj.width - this.clipData.width) / 2;
                return left + "px";
            }
        },
        setImgCenter: function setImgCenter(className) {
            var top = (this.screenObj.height - this.clipImg.height) / 2;
            var left = (this.screenObj.width - this.clipImg.width) / 2;
            var uploadImg = document.querySelector(className);
            if (this.clipImg.width >= this.screenObj.width) {
                uploadImg.setAttribute('style', "top:" + top + "px;left:" + left + "px");
            }
            if (this.clipImg.height >= this.screenObj.height) {
                uploadImg.setAttribute('style', "top:" + top + "px;left:" + left + "px");
            }
        },
        bindEvents: function bindEvents(touchPad, img) {
            var offx = 0,
                offy = 0;
            var scale = 1;
            var currScale = void 0;
            var _this = this;

            function formatTransform(offx, offy, scale) {
                var translate = 'translate3d(' + (offx + 'px,') + (offy + 'px,') + '0)';
                scale = 'scale(' + scale + ')';
                return translate + ' ' + scale;
            }

            touch.on(touchPad, 'touchstart', function (ev) {
                ev.preventDefault();
            });

            touch.on(touchPad, 'drag', function (ev) {
                var currOffx = offx + ev.x;
                var currOffy = offy + ev.y;
                img.style.webkitTransform = formatTransform(currOffx, currOffy, scale);
            });

            touch.on(touchPad, 'dragend', function (ev) {
                offx += ev.x;
                offy += ev.y;
                _this.clipImg.left = offx;
                _this.clipImg.top = offy;
                _this.clipImg.lastScale = _this.clipImg.scale;
            });

            touch.on(touchPad, 'pinch', function (ev) {
                if (typeof ev.scale != 'undefined') {
                    currScale = ev.scale - 1 + scale;
                    if (currScale <= 0) {
                        currScale = 0.1;
                    }
                    img.style.webkitTransform = formatTransform(offx, offy, currScale);
                }
            });

            touch.on(touchPad, 'pinchend', function () {
                scale = currScale;
                _this.clipImg.scale = scale;
            });
        },
        drawImg: function drawImg(cb) {
            var canvas = document.createElement('canvas');
            var context = canvas.getContext('2d');
            var img = document.querySelector('.clip-img');

            this.computer();

            var dw = this.clipData.width * this.clipData.rate;
            var dh = this.clipData.height * this.clipData.rate;
            var dx = this.clipImg.dx * this.clipData.rate;
            var dy = this.clipImg.dy * this.clipData.rate;
            var url = void 0;

            canvas.width = dw;
            canvas.height = dh;
            context.fillStyle = this.clipData.background;
            context.fillRect(0, 0, dw, dh);
            context.drawImage(img, this.clipImg.sx, this.clipImg.sy, this.clipImg.sw, this.clipImg.sh, dx, dy, dw, dh);
            context.restore();
            url = canvas.toDataURL('image/png');
            canvas.toBlob(function (blob) {
                cb && cb(blob, url);
            }, 'image/jpeg', 0.8);
        },
        computer: function computer() {
            var imgObj = this.clipImg;
            var clipW = this.clipData.width;
            var clipH = this.clipData.height;
            if (imgObj.scale == 1) {
                imgObj.sx = ((imgObj.width - clipW) / 2 - imgObj.left) / imgObj.rate;
                imgObj.sy = ((imgObj.height - clipH) / 2 - imgObj.top) / imgObj.rate;
                imgObj.sw = clipH / imgObj.rate / imgObj.scale;
                imgObj.sh = clipH / imgObj.rate / imgObj.scale;
                imgObj.dx = 0;
                imgObj.dy = 0;
            } else {
                if (imgObj.scale == imgObj.lastScale) {
                    if (imgObj.width * imgObj.scale < clipW) {
                        imgObj.sx = 0;
                    } else {
                        imgObj.sx = ((imgObj.width - clipW / imgObj.scale) / 2 - imgObj.left / imgObj.scale) / imgObj.rate;
                    }
                    if (imgObj.height * imgObj.scale < clipH) {
                        imgObj.sy = 0;
                    } else {
                        imgObj.sy = ((imgObj.height - clipH / imgObj.scale) / 2 - imgObj.top / imgObj.scale) / imgObj.rate;
                    }
                } else {
                    if (imgObj.width * imgObj.scale - imgObj.left < clipW) {
                        imgObj.sx = 0;
                    } else {
                        imgObj.sx = ((imgObj.width - clipW / imgObj.scale) / 2 - imgObj.left / imgObj.scale) / imgObj.rate;
                    }
                    if (imgObj.height * imgObj.scale - imgObj.top < clipH) {
                        imgObj.sy = 0;
                    } else {
                        imgObj.sy = ((imgObj.height - clipH / imgObj.scale) / 2 - imgObj.top / imgObj.scale) / imgObj.rate;
                    }
                }

                imgObj.sw = clipH / imgObj.rate / imgObj.scale;
                imgObj.sh = clipH / imgObj.rate / imgObj.scale;

                if (imgObj.scale == imgObj.lastScale) {
                    if (clipW < imgObj.width * imgObj.scale) {
                        imgObj.dx = 0;
                    } else {
                        imgObj.dx = (clipW - imgObj.width * imgObj.scale) / 2 + imgObj.left;
                    }
                    if (clipH < imgObj.height * imgObj.scale) {
                        imgObj.dy = 0;
                    } else {
                        imgObj.dy = (clipH - imgObj.height * imgObj.scale) / 2 + imgObj.top;
                    }
                } else {
                    if (imgObj.width * imgObj.scale - clipW - imgObj.left > 0) {
                        imgObj.dx = 0;
                    } else {
                        imgObj.dx = (clipW - imgObj.width * imgObj.scale) / 2 + imgObj.left;
                    }
                    if (imgObj.height * imgObj.scale - clipH - imgObj.top > 0) {
                        imgObj.dy = 0;
                    } else {
                        imgObj.dy = (clipH - imgObj.height * imgObj.scale) / 2 + imgObj.top;
                    }
                }
            }
        },
        saveClipImg: function saveClipImg() {
            console.log(111);
            var _this = this;

            _this.drawImg(function (file, data) {

                var curIndex = _this.imagePreviewList.length - 1;

                _this.imagePreviewList[curIndex].data = data;
                _this.uploadFile(file, curIndex);
            });

            this.showClip = false;
        },
        uploadFile: function uploadFile(file, curIndex) {

            var _this = this;
            var formData = new FormData();

            formData.append(_this.name, file);

            for (var key in _this.extraData) {
                formData.append(key, _this.extraData[key]);
            }

            var _data = null;
            _this.$http.post(_this.url, formData).then(function (res) {
                _data = res.body;
                _this.imagePreviewList[curIndex].isUploading = false;

                var _result = _this.onSuccess && _this.onSuccess(_data, _this.imagePreviewList[curIndex], _this.imagePreviewList);
                if (_result === false) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(_data);
                } else {
                    return _result;
                }
            }).catch(function (res) {
                _this.imagePreviewList[curIndex].isError = true;
                _this.imagePreviewList[curIndex].isUploading = false;

                _this.onError && _this.onError(res, _this.imagePreviewList[curIndex], _this.imagePreviewList);
            }).finally(function () {
                _this.onComplete && _this.onComplete(_data, _this.imagePreviewList[curIndex], _this.imagePreviewList);
            });
        }
    }

});

/***/ }),

/***/ 42:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(38);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(78)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(84),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-32f99c87",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\project\\vue2-img-upload\\src\\components\\ImgUpload.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] ImgUpload.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32f99c87", Component.options)
  } else {
    hotAPI.reload("data-v-32f99c87", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showClip),
      expression: "!showClip"
    }],
    staticClass: "evaluateImgCon"
  }, [_vm._l((_vm.imagePreviewList), function(img, index) {
    return _c('section', {
      staticClass: "evaluateImgItem",
      class: {
        uploading: img.isUploading, error: img.isError
      },
      attrs: {
        "track-by": "$index"
      }
    }, [_c('img', {
      staticClass: "evaluateImg",
      attrs: {
        "alt": "",
        "src": img.data
      },
      on: {
        "click": function($event) {
          _vm.imgSwiper(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "uploading-box"
    }, [_vm._v("上传中...")]), _vm._v(" "), _c('div', {
      staticClass: "error-box"
    }, [_vm._v("上传失败")]), _vm._v(" "), (index === 0) ? _c('div', {
      staticClass: "cover"
    }, [_vm._v("封面")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "delIcon",
      on: {
        "click": function($event) {
          _vm.delImage(index, img)
        }
      }
    })])
  }), _vm._v(" "), (_vm.imagePreviewList.length < _vm.max) ? _c('div', {
    staticClass: "evaluateUploadImg",
    on: {
      "click": function($event) {
        _vm.openUploadPop($event)
      }
    }
  }, [_c('span', {
    staticClass: "uploadIcon"
  }), _vm._v(" "), (_vm.isClip) ? [_c('input', {
    ref: "upload",
    staticClass: "uploadFile",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.uploadImg
    }
  })] : _vm._e(), _vm._v(" "), (!_vm.isClip) ? [(_vm.isIOS || !_vm.isWx) ? _c('input', {
    ref: "upload",
    staticClass: "uploadFile",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadImg
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isIOS && _vm.isWx) ? _c('input', {
    ref: "upload",
    staticClass: "uploadFile",
    attrs: {
      "type": "file",
      "accept": "image/*",
      "capture": "camera",
      "multiple": ""
    },
    on: {
      "change": _vm.uploadImg
    }
  }) : _vm._e()] : _vm._e()], 2) : _vm._e()], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSwiper),
      expression: "isSwiper"
    }],
    staticClass: "swiper-layout"
  }, [_c('div', {
    staticClass: "swiper-container",
    on: {
      "click": _vm.hideSwiper
    }
  }, [_c('div', {
    staticClass: "swiper-guide"
  }, [_c('span', [_vm._v(_vm._s(_vm.currSwiperIndex))]), _vm._v("/"), _c('span', [_vm._v(_vm._s(_vm.imagePreviewList.length))])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.imagePreviewList), function(img, index) {
    return _c('div', {
      staticClass: "swiper-slide"
    }, [_c('img', {
      attrs: {
        "src": img.data,
        "alt": ""
      }
    })])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isClip && _vm.showClip),
      expression: "isClip && showClip"
    }],
    staticClass: "clip-container"
  }, [_c('img', {
    staticClass: "clip-img",
    attrs: {
      "src": _vm.clipImgUrl,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clip-wrap"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showClip),
      expression: "showClip"
    }],
    staticClass: "clip-save-btn",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
        _vm.saveClipImg($event)
      },
      "touchmove": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        $event.preventDefault();
      }
    }
  }, [_vm._v("保存效果")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-32f99c87", module.exports)
  }
}

/***/ }),

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img-upload', {
    attrs: {
      "image-preview-list": _vm.images,
      "on-success": _vm.onSuccess,
      "on-error": _vm.onError,
      "on-complete": _vm.onComplete,
      "before-upload": _vm.beforeUpload,
      "max": 9,
      "url": _vm.url,
      "extra-data": _vm.extraData,
      "is-preview": true,
      "is-clip": true,
      "clip-data": {
        width: 290,
        height: 290,
        rate: 3,
        background: '#fff'
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("后端接口地址："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v("————————修改日志————————")]), _vm._v(" "), _c('p', [_vm._v("2018-01-18：修复IOS下微信只能打开相机的bug")]), _vm._v(" "), _c('p', [_vm._v("2018-01-04：新增图片裁剪的功能(只支持单张上传)")]), _vm._v(" "), _c('p', [_vm._v("2017-09-20：修复UC等浏览器上无法选择相册图片的bug")]), _vm._v(" "), _c('p', [_vm._v("2017-09-19：优化onSuccess钩子，添加onError、onComplete、beforeUpload等钩子")]), _vm._v(" "), _c('p', [_vm._v("2017-09-19：修复连续选取同一文件时不触发onchange事件的bug")]), _vm._v(" "), _c('p', [_vm._v("2017-09-18：迁移至vue2.0")]), _vm._v(" "), _c('p', [_vm._v("2016-12-05：添加图片点击预览大图功能")]), _vm._v(" "), _c('p', [_vm._v("2016-12-02：支持由外部传入的图片数组")]), _vm._v(" "), _c('p', [_vm._v("2016-11-30：发出请求后的回调处理改为由外部传入回调函数")]), _vm._v(" "), _c('p', [_vm._v("2016-11-27：v1.0，支持前端压缩、IOS图片方向修复、选择多张图片等功能")]), _vm._v(" "), _vm._m(0, false, false)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("confluence地址："), _c('a', {
    attrs: {
      "href": "http://confluence.daojia-inc.com/pages/viewpage.action?pageId=32675115",
      "target": "_blank"
    }
  }, [_vm._v("html5移动端上传图片的解决方案及vue实现（v1.0）")])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-57da2ff5", module.exports)
  }
}

/***/ }),

/***/ 87:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[42]);


// WEBPACK FOOTER //
// js/my-index.js